import { render, staticRenderFns } from "./MaterialTransfer.vue?vue&type=template&id=174b9687"
import script from "./MaterialTransfer.vue?vue&type=script&lang=js"
export * from "./MaterialTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports